"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndexHeight = exports.formatdata = void 0;
/**
 * 通用数据格式化
 */
function formatdata(opts, trendsTotal, arr_yaxis) {
    /** 过滤掉不符合的数据 */
    if (trendsTotal === void 0) { trendsTotal = 241; }
    var newarr = arr_yaxis.filter(function (val) {
        if (val !== undefined && val !== "" && val !== " " && val !== "-") {
            return true;
        }
    });
    var yAxisMax = 0, yAxisMin = 0, x_scale = 1, y_scale = 1, yPointUnit = 0;
    if (!!newarr.length) {
        var min = Math.min.apply(Math, newarr);
        var max = Math.max.apply(Math, newarr);
        yAxisMax = Math.abs(min) > max ? Math.abs(min) : max;
        if (yAxisMax != 0) {
            yAxisMax = Math.ceil(yAxisMax * 1.05);
        }
        else {
            yAxisMax = 3;
        }
        x_scale = (opts.width - opts.padding.l - opts.padding.r) / trendsTotal;
        // y_scale = (opts.height - opts.padding.t - opts.padding.b) / (yAxisMax - yAxisMin)
        // yPointUnit =(yAxisMax-yAxisMin)/opts.split.y
    }
    yPointUnit = (opts.height - opts.padding.t - opts.padding.b - opts.topinfoheight - opts.bottominfoheight) / (opts.yaxis.pointnum - 1);
    var ypoints = [0]; // y周分割序列
    for (var i = 1, len = 2; i <= len; i++) {
        ypoints.push(yAxisMax / len * i);
    }
    var yAxisPoints = transYPoints(ypoints);
    return {
        x_scale: x_scale,
        yAxisMax: yAxisMax,
        yAxisMin: yAxisMin,
        yPointUnit: yPointUnit,
        yAxisPoints: yAxisPoints
    };
}
exports.formatdata = formatdata;
/**
 * y 坐标轴正负转换
 */
function transYPoints(arr) {
    try {
        var prearr = arr.slice(1).reverse().map(function (v) { return v * (-1); });
        var back = prearr.concat(arr);
        return back;
    }
    catch (error) {
        return [];
    }
}
/**
 * y值转换y坐标位置
 */
function getIndexHeight(itemY, opts, commondata) {
    var padding = opts.padding, topinfoheight = opts.topinfoheight, height = opts.height, fontsize = opts.fontsize;
    var y1 = padding.t + topinfoheight; // y上限
    var y2 = height - padding.b - fontsize * 1.5; // y下限
    var diff = y2 - y1;
    var h = itemY / commondata.yAxisMax * diff / 2;
    var midy = y1 + diff / 2; //  折线区域中线y坐标
    return midy - h;
}
exports.getIndexHeight = getIndexHeight;
